import { render } from "./Attendees.vue?vue&type=template&id=2487f92d&scoped=true"
import script from "./Attendees.vue?vue&type=script&lang=js"
export * from "./Attendees.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2487f92d"

export default script